import { useCallback } from "react";
import ReceiptPaymentModeSummary from "@/components/receipt-payment-summary/ReceiptPaymentModeSummary";
import type { PaymentSummaryResponse } from "@/components/receipt-payment-summary/types";
import { useRouteId } from "@/utils/route-utility";
import {
  buildNiyaazSummaryQuery,
  NIYAAZ_PAYMENT_SUMMARY_PATH,
  NIYAAZ_SUMMARY_QUERY_KEYS,
  niyaazPaymentSummaryCardsFromResponse,
  shouldFetchNiyaazPaymentSummary,
  withResolvedNiyaazEventId,
} from "./niyaaz-receipt-payment-summary";

const parseNiyaazPaymentSummaryResponse = (json: unknown): PaymentSummaryResponse | null =>
  json && typeof json === "object" ? (json as PaymentSummaryResponse) : null;

export default function NiyaazReceiptPaymentSummary() {
  const routeEventId = useRouteId();

  const shouldFetch = useCallback(
    (filterValues: Record<string, unknown>) =>
      shouldFetchNiyaazPaymentSummary(withResolvedNiyaazEventId(filterValues, routeEventId)),
    [routeEventId]
  );

  const buildQuery = useCallback(
    (filterValues: Record<string, unknown>) =>
      buildNiyaazSummaryQuery(withResolvedNiyaazEventId(filterValues, routeEventId)),
    [routeEventId]
  );

  return (
    <ReceiptPaymentModeSummary
      apiResource="niyaazReceipts"
      summaryPath={NIYAAZ_PAYMENT_SUMMARY_PATH}
      queryKeys={NIYAAZ_SUMMARY_QUERY_KEYS}
      shouldFetch={shouldFetch}
      buildQuery={buildQuery}
      parseResponse={parseNiyaazPaymentSummaryResponse}
      cardsFromResponse={niyaazPaymentSummaryCardsFromResponse}
    />
  );
}
